import { useQuery } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

// 팝업 목록 조회
export const useGetPopupList = (p_type: string, page: string, searchtxt: string) => {
    return useQuery({
        queryKey: ["popupList", p_type, page, searchtxt],
        queryFn: async () => {
            const res = await consoleAxios.get(
                `${CONSOLE_API_ROUTES.POPUP}?p_type=${p_type}&p_lang=KR&page=${page}&searchtxt=${searchtxt}`,
            );
            return res.data;
        },
    });
};
